import mapboxgl from 'mapbox-gl'

export default async ({ app, router, Vue }) => {
  mapboxgl.accessToken = 'pk.eyJ1IjoiYmxvdXplIiwiYSI6ImNqdG15ZDZpZDF2N2k0NW82emp1MzhoZnEifQ.wA_TJHFrGpVf46poCTacLg'
}
